import { IShimmerStyles, memoizeFunction, mergeStyleSets } from '@fluentui/react';
import { IAppTheme } from 'common/theme/AppTheme';

const baseline = 8;
const size = {
  xxl: baseline * 6,
  xl: baseline * 5,
  lg: baseline * 4,
  md: baseline * 3,
  sm: baseline * 2,
  xs: baseline,
} as const;

export const getShimmerStyles = memoizeFunction((customStyles?: IShimmerStyles, fullWidth?: boolean) =>
  mergeStyleSets(
    {
      shimmerWrapper: {
        borderRadius: size.xs,
      },
    } as IShimmerStyles,
    fullWidth && {
      root: {
        width: '100%',
      },
    },
    customStyles
  )
);

export const getShimmerCardStyles = memoizeFunction((theme: IAppTheme) =>
  mergeStyleSets({
    shimmerCard: {
      padding: size.md,
      borderRadius: size.xs,
      boxSizing: 'border-box',
      alignItems: 'flex-start',
      width: '100%',
    },
    shimmerCardWhite: {
      background: theme.appColors?.white40ToAnchor30tr40,
      border: `1px solid ${theme.palette.white}`,
    },
  })
);
